import { ScrollView, View } from 'react-native';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CheckoutTable from './components/CheckoutTable';
import { Footer } from '../../../components/Footer';
import { FC } from 'react';
import { styles } from './CheckoutPage.styled';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { EShopLayout } from '../../../WebLayout';
import { NavigationService } from '../../../services/navigation';

const CheckoutPage: FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop()) {
    return (
      <EShopLayout
        title="Checkout"
        icon={require('../../../assets/checkout.png')}
      >
        <CheckoutTable />
      </EShopLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Checkout"
          icon={require('../../../assets/checkout.png')}
          haveGoBackButton={true}
          handleGoBack={() => NavigationService.goBack()}
          haveBottomLine={false}
        />
      </View>
      <CheckoutTable />
      <Footer />
    </ScrollView>
  );
};

export default CheckoutPage;
